import { keyPicker, tagAs } from 'factions/metatagger'
import {
  COMBAT_PHASE,
  DURING_GAME,
  END_OF_COMBAT_PHASE,
  END_OF_MOVEMENT_PHASE,
  HERO_PHASE,
  SAVES_PHASE,
  START_OF_BATTLESHOCK_PHASE,
  START_OF_COMBAT_PHASE,
  START_OF_HERO_PHASE,
} from 'types/phases'
import rule_sources from './rule_sources'
import spells from './spells'
import { TItemDescriptions } from 'factions/factionTypes'

const Artifacts = {
 /* 'The Splithorn Helm': {
    effects: [
      {
        name: `The Splithorn Helm`,
        desc: `The bearer has a Disgustingly Resilient ward of 4+.`,
        when: [SAVES_PHASE],
      },
    ],
  },
  Muttergrub: {
    mandatory: {
      spells: [keyPicker(spells, ['Gift of Disease'])],
    },
    effects: [
      {
        name: `Muttergrub`,
        desc: `The bearer can attempt to cast the Gift of Disease spell (pg 66) in your hero phase in the same manner as a WIZARD. If the bearer is a WIZARD, they know the Gift of Disease spell in addition to the spell you can normally pick for them from the Lore of Malignance, and you can add 1 to the casting roll when they attempt to cast Gift of Disease.`,
        when: [HERO_PHASE],
      },
    ],
  },
  Rustfang: {
    effects: [
      {
        name: `Rustfang`,
        desc: `Once per battle, at the start of the combat phase, you can pick 1 enemy HERO within 3" of the bearer. Subtract 1 from save rolls for attacks that target that HERO for the rest of the battle.`,
        when: [START_OF_COMBAT_PHASE],
      },
    ],
  },
  'Flesh Peeler': {
    effects: [
      {
        name: `Flesh Peeler`,
        desc: `In your hero phase, roll a dice for each enemy unit that is within 7" of the bearer. On a 4+, give that unit 1 disease point.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'The Fecund Flask': {
    effects: [
      {
        name: `The Fecund Flask`,
        desc: `Once per battle, at the start of your hero phase, you can say the bearer will drink from the Fecund Flask. If you do so, roll a dice. On a 2+, heal all wounds allocated to the bearer. On a 1, the bearer is slain. If the bearer is slain by this artefact, before they are removed from play, you can add 1 BEASTS OF NURGLE unit that has 1 model to your army and set it up within 1" of the bearer. The BEASTS OF NURGLE unit can only be set up within 3" of an enemy unit if the bearer was within 3" of that enemy unit when they were slain.`,
        when: [START_OF_HERO_PHASE],
        rule_sources: [rule_sources.BATTLETOME_NURGLE, rule_sources.ERRATA_JANUARY_2022],
      },
    ],
  },
  'Noxious Nexus': {
    effects: [
      {
        name: `Noxious Nexus`,
        desc: `If an enemy unit is within 3" of the bearer at the end of the movement phase or combat phase, give 2 disease points to that unit instead of 1 for being within 3" of any friendly MAGGOTKIN OF NURGLE units.`,
        when: [END_OF_MOVEMENT_PHASE, END_OF_COMBAT_PHASE],
        rule_sources: [rule_sources.BATTLETOME_NURGLE, rule_sources.ERRATA_JANUARY_2022],
      },
    ],
  },
  "Nurgle's Nail": {
    effects: [
      {
        name: `Nurgle's Nail`,
        desc: `Pick one of the bearer's melee weapons. Attacks made with that weapon inflict 1 disease point on the target unit on an unmodified hit roll of 5 or 6.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'The Bountiful Swarm': {
    effects: [
      {
        name: `The Bountiful Swarm`,
        desc: `Once per battle, at the start of your hero phase, pick 1 enemy model within 3" of the bearer and then roll a dice. If the roll is greater than that model's Wounds characteristic, it is slain. If that model is slain and had a Wounds characteristic of 4 or more, before it is removed from play, you can add 1 BEASTS OF NURGLE unit that has 1 model to your army and set it up within 1" of the slain model. The BEASTS OF NURGLE unit can only be set up within 3" of an enemy unit if the model was within 3" of that enemy unit when it was slain.`,
        when: [START_OF_HERO_PHASE],
      },
    ],
  },
  'The Witherstave': {
    effects: [
      {
        name: `The Witherstave`,
        desc: `Add 1 to disease rolls for enemy units that are within 7" of the bearer.`,
        when: [START_OF_BATTLESHOCK_PHASE],
      },
    ],
  },
  'Tome of a Thousand Poxes': {
    mandatory: {
      spells: [keyPicker(spells, ['Gift of Disease'])],
    },
    effects: [
      {
        name: `Tome of a Thousand Poxes`,
        desc: `The bearer can attempt to cast the Gift of Disease spell (pg 66) in your hero phase in the same manner as a WIZARD. If the bearer is a WIZARD, they know the Gift of Disease spell in addition to the spell you can normally pick for them from the Lore of Virulence, and you can add 1 to the casting roll when they attempt to cast Gift of Disease.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'The Endless Gift': {
    effects: [
      {
        name: `The Endless Gift`,
        desc: `The bearer is always treated as being within 14" of a Locus of Fecundity.`,
        when: [DURING_GAME],
      },
    ],
  }, */
  'The Witherstave': {
    effects: [
      {
        name: `The Witherstave`,
        desc: `Declare: Pick an enemy unit that charged this turn and is in combat with this unit to be the target. 
        Effect: Roll a dice. On a 4+, the target has Strike-last for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Rustfang': {
    effects: [
      {
        name: `Rustfang - Once Per Battle`,
        desc: `Declare: Pick an enemy Hero in combat with this unit to be the target. 
        Effect: Subtract 1 from save rolls for the target for the rest of the battle.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'The Carrion Dirge': {
    effects: [
      {
        name: `The Carrion Dirge - Once Per Battle`,
        desc: `You can reroll save rolls for attacks that target the bearer if the save roll is equal to or less than the number of wounds allocated to the bearer.`,
        when: [HERO_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(Artifacts, 'artifact')
